import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { AbsenceEntity } from '@wilson/interfaces';
import {
  DropZoneEventThrottlerDirective,
  GanttDateToPositionPxPipe,
} from '@wilson/shift-timeline/assignments-gantt-chart';
import {
  CreateNewViaDragAndDropService,
  DragAndDropModeService,
  HorizontalDemarcatorRange,
} from '@wilson/shift-timeline/services';
import {
  ShiftTimelineSettingsState,
  TimelineRemoveAbsence,
  TimelineStaysSuggestionService,
} from '@wilson/shift-timeline/state';
import { NewAbsenceDropZoneService } from './new-absence-drop-zone.service';

@Component({
  selector: 'wilson-new-absence-drop-zone',
  imports: [],
  template: '',
  styleUrls: ['./new-absence-drop-zone.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [GanttDateToPositionPxPipe],
})
export class NewAbsenceDropZoneComponent extends DropZoneEventThrottlerDirective {
  private store = inject(Store);
  private readonly dragAndDropModeService = inject(DragAndDropModeService);
  private readonly newAbsenceDropZoneService = inject(
    NewAbsenceDropZoneService,
  );
  protected timelineStaysSuggestionService = inject(
    TimelineStaysSuggestionService,
  );

  @Input() userId!: string | undefined;

  private mockAbsence!: undefined | (AbsenceEntity & { id: string });
  private currentDemarcatorRange: HorizontalDemarcatorRange | null = null;
  private OFFSETX_ADJUSTMENT_RATIO = 3;

  protected async onDropHandler() {
    if (this.currentDemarcatorRange && this.mockAbsence && this.userId) {
      this.newAbsenceDropZoneService.handleOnDropProcess({
        currentDemarcatorRange: this.currentDemarcatorRange,
        mockAbsence: this.mockAbsence,
        userId: this.userId,
      });
    }
  }

  protected onDragLeaveHandler() {
    if (this.userId) {
      this.removeMockAbsenceFromState(this.userId);
    }

    this.dragAndDropModeService.setDisplayMovingDemarcatorLine(false);
  }

  protected onDragOverHandler(offsetX: number) {
    const processingResult =
      this.newAbsenceDropZoneService.handleOnDragOverProcess({
        offsetX:
          offsetX -
          this.store.selectSnapshot(
            ShiftTimelineSettingsState.pixelWidthPerDay(),
          ) /
            this.OFFSETX_ADJUSTMENT_RATIO,
        userId: this.userId,
        isFullDay: false,
      });

    if (processingResult) {
      this.currentDemarcatorRange = processingResult.currentDemarcatorRange;
      this.mockAbsence = processingResult.mockAbsence;
    }
  }

  private removeMockAbsenceFromState(userId: string) {
    this.store.dispatch(
      new TimelineRemoveAbsence({
        absenceId: CreateNewViaDragAndDropService.MOCK_ABSENCE_ID,
        userId: userId,
      }),
    );
  }
}
